import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app';
import { AppConstants } from './app/app.constants';
import { startBugsnag } from '@spotlight/shared/error-tracking';
import { unregisterServiceWorkers } from '@spotlight/shared/legacy-service-worker';
import { SharedConstants } from './app/shared/shared.constants';
import { stripLocationPrefix } from './app/shared/navbar/location-utils';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

startBugsnag({
  apiKey: SharedConstants.bugsnagApiKey,
  releaseStage: environment.env,
  appVersion: document.querySelector<HTMLMetaElement>('meta[name="application-version"]')?.content ?? '',
  // Group by route, not by restaurant: /01234/customers → /customers
  normalizePath: stripLocationPrefix
});

if (environment.production) {
  unregisterServiceWorkers();
}

const hostname = location.hostname;
// This is for production when the  hostname is 'spotlight.cfahome.com'
let faviconUrl = AppConstants.productionFaviconUrl;

if (hostname === 'localhost') {
  faviconUrl = AppConstants.localFaviconUrl;
} else if (hostname === 'spotlight.cfaspotlighttest.cfadevelop.com' || hostname === 'spotlight.cfaspotlightdev.cfadevelop.com') {
  faviconUrl = AppConstants.qaFaviconUrl;
}

const faviconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
if (faviconLink) {
  faviconLink.href = faviconUrl;
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));

